export const generateMwaList = (questionsArray, followUp, reasons) => {
    let activityQuestionJson = null;
    let activityQuestionComment = null;
    let encapTechRequiredId = 999999999;
    let encapAccessibleByVehicule = 999999998;
    const followUpType = followUp.followUpTpyeId || followUp.followUpTypeId || followUp.id;
    if (
        questionsArray &&
        followUp.uuid &&
        !Array.isArray(questionsArray) &&
        typeof questionsArray === "object" &&
        Object.keys(questionsArray).length > 0
    ) {
        const mappedQuestions = questionsArray[followUp.uuid]?.mappedQuestions;
        let activityQuestionCommentJson = {};
        if (Array.isArray(mappedQuestions) && mappedQuestions.length > 0) {
            const result = {};
            const filteredQuestions = mappedQuestions.filter((q) => q.questionType !== "file" && q.questionType !== "sketch");

            filteredQuestions.forEach((question) => {
                if (question.id != encapTechRequiredId && question.id != encapAccessibleByVehicule) {
                    if (question.isAnswered && question.value !== undefined) {
                        result[question.id] = question.value;
                    }
                } else {
                    if (question.isAnswered && question.value !== undefined && question.value !== null && question.value !== "") {
                        if (question.id == encapTechRequiredId) {
                            activityQuestionCommentJson["reason_Dig"] = question.value;
                        }
                        if (question.id == encapAccessibleByVehicule) {
                            activityQuestionCommentJson["comment_Vehicles"] = question.value;
                        }
                    }
                }
            });
            activityQuestionJson = JSON.stringify(result);
            activityQuestionComment = JSON.stringify(activityQuestionCommentJson);
        }
    }

    const {
        nameEn = null,
        nameFr = null,
        workActivityID = followUp.workActivityID || null,
        workTypeID = followUp.workTypeId || null,
    } = reasons.find((r) => r.followUpTypeID === followUpType) || {};
    return [
        {
            activity: {
                id: workActivityID,
                name_en: nameEn,
                name_fr: nameFr,
                workType_Id: workTypeID,
                odmFieldName: nameEn,
            },
            displayPriority: 0,
            inputRequestActivityId: workActivityID,
            activityQuestionJson,
            activityQuestionComment,
        },
    ];
};

